import React, { useEffect, createElement } from 'react';
interface WistiaPlayerProps {
  mediaId: string;
  className?: string;
}
// Inject the global Wistia player loader script once per page
function ensurePlayerScript() {
  if (typeof document === 'undefined') return;
  if (document.querySelector('script[data-wistia-player]')) return;
  const s = document.createElement('script');
  s.src = 'https://fast.wistia.com/player.js';
  s.async = true;
  s.setAttribute('data-wistia-player', 'true');
  document.head.appendChild(s);
}
// Inject the per-media module script once per media id
function ensureMediaScript(mediaId: string) {
  if (typeof document === 'undefined') return;
  const attr = `data-wistia-media-${mediaId}`;
  if (document.querySelector(`script[${attr}]`)) return;
  const s = document.createElement('script');
  s.src = `https://fast.wistia.com/embed/${mediaId}.js`;
  s.async = true;
  s.type = 'module';
  s.setAttribute(attr, 'true');
  document.head.appendChild(s);
}
export function WistiaPlayer({
  mediaId,
  className = ''
}: WistiaPlayerProps) {
  useEffect(() => {
    ensurePlayerScript();
    ensureMediaScript(mediaId);
  }, [mediaId]);
  // The swatch placeholder style must be scoped per media id, exactly as Wistia recommends
  const placeholderCss = `wistia-player[media-id='${mediaId}']:not(:defined) { background: center / contain no-repeat url('https://fast.wistia.com/embed/medias/${mediaId}/swatch'); display: block; filter: blur(5px); padding-top:56.25%; }`;
  return <div className={`w-full bg-white border border-line rounded-[12px] overflow-hidden ${className}`} data-id="element-137">
      <style dangerouslySetInnerHTML={{
      __html: placeholderCss
    }} data-id="element-138" />
      {/* @ts-expect-error custom element */}
      <wistia-player media-id={mediaId} aspect="1.7777777777777777" data-id="element-139"></wistia-player>
    </div>;
}